import { Button, Hairline, Input } from "@components";
import { Case, If, Switch } from "@components/control-statements";
import { FlowAPI } from "@providers/FlowAPI";
import React from "react";

import { Environment } from "@core/Environment";
import styles from "@styles/forms-flow/creative.module.scss";
import classNames from "classnames/bind";
import debounce from "lodash.debounce";
const css = classNames.bind(styles);

export class UploadEmailHtml extends React.Component {
  state = {
    status: "",
    fileName: "",
    testShooting: {
      email: null,
      waiting: null,
    },
  };

  constructor(props) {
    super(props);
    this.onSendEmail = debounce(this.shootAndStartTimer.bind(this), 1000);
  }

  onSendEmail() {}

  async setStateAsync(data) {
    return new Promise((resolve) => this.setState(data, resolve));
  }

  async uploadFile(e) {
    const file = e.target.files[0];

    if (file) {
      const maxFileSize = 5;
      const fileSize = file.size / 1024 / 1024;
      const fileType = file.type;

      if (fileSize > maxFileSize) {
        alert({ text: `Escolha um arquivo com no máximo ${maxFileSize}MB` });
        return false;
      }

      const pattern = /text-*/;

      if (!fileType.match(pattern)) {
        alert({ text: "Arquivo inválido." });
        return false;
      }

      const reader = new FileReader();
      await this.setStateAsync({ status: "uploading" });

      reader.onload = async (readerEvent) => {
        const response = await FlowAPI.putEmailResource({
          environmentId: Environment.id,
          mimeType: fileType,
          file: readerEvent.target.result.split("base64,")[1],
        });

        const responseData = response.getData({ fileName: "" });
        const fileName = responseData?.fileName;
        await this.setStateAsync({ status: fileName ? "success" : "error" });
        this.setMessage({ filename: fileName });
      };

      reader.readAsDataURL(file);
    }
  }

  setMessage(data) {
    const { message, onChangeCreative } = this.props;
    if (onChangeCreative) {
      onChangeCreative({ ...(message || {}), ...data, type: "EMAIL" });
    }
  }

  async shootAndStartTimer() {
    const { testShooting } = this.state;
    const { message, coupon, url } = this.props;

    const response = await FlowAPI.sendEmailTest(Environment.id, {
      template: message.filename,
      subject: message.subject,
      emails: [
        {
          email: testShooting.email,
          replacements: {
            "{link}":
              url?.type == "CUSTOM" ? url?.url : Environment.defaultShortUrl,
            "{cupom}": coupon?.code ? `${coupon?.code}-PIN` : "",
          },
        },
      ],
      ...(message.senderAddress
        ? { senderAddress: message.senderAddress }
        : {}),
      ...(message.senderName ? { senderName: message.senderName } : {}),
    });

    if (response.getErrors([]).length > 0) {
      alert({ text: response.getErrors(["Ocorreu um erro no sistema!"]) });
      return;
    }

    await this.setStateAsync({
      testShooting: { ...testShooting, remainTime: 180 },
    });
    const intervalId = setInterval(async () => {
      const { remainTime } = this.state.testShooting;
      await this.setStateAsync({
        testShooting: {
          ...this.state.testShooting,
          remainTime: remainTime - 1,
        },
      });

      if (remainTime == 0) {
        clearInterval(intervalId);
      }
    }, 1000);
  }

  renderShootingTest() {
    const { testShooting } = this.state;
    const { email, remainTime } = testShooting;
    const { message } = this.props;

    console.log(email)
    return (
      <>
        <Hairline className="mt-20 mb-30" />
        <p className={styles.label}>Enviar simulação</p>
        <p className={styles.sublabel}>
          Informe o seu email para que possamos realizar uma simulação de envio.
        </p>
        <div className={styles.testMessage}>
          <Input
            prefix="Email"
            prefixWidth={65}
            className="w-100"
            value={email}
            onChange={(e) =>
              this.setState({
                testShooting: { ...testShooting, email: e.target.value },
              })
            }
          />
          <Button
            design="four"
            className="mt-20 w-100"
            disabled={remainTime > 0 || !email || !message?.filename}
            onClick={this.onSendEmail.bind(this)}
          >
            Disparar
            <If cond={remainTime > 0}>
              <span>
                &nbsp;(
                {`${`${Math.floor(remainTime / 60)}`.padStart(2, "0")}:${`${
                  remainTime % 60
                }`.padStart(2, "0")}`}
                )
              </span>
            </If>
          </Button>
        </div>
      </>
    );
  }

  render() {
    const { status } = this.state;
    const { message, restrictions } = this.props;

    return (
      <>
        <p className={styles.label}>Email</p>
        <Input
          prefix="Assunto"
          placeholder="Nome do assunto"
          prefixWidth={100}
          value={message?.subject}
          onChange={(text) => this.setMessage({ subject: text.target.value })}
          autoFocus
        />

        <Hairline solid className="mt-20 mb-20" />

        <p className={styles.label}>Conteúdo do email</p>
        
        <div className={styles.messageUploadHtml}>
          <div className={styles.dot} />
          <p>
            Caso queira, inclua a lacuna da URL rastreável no código HTML.
            Basta incluir <span>{`{link}`}</span> no local que desejar.
          </p>
        </div>
        
        <label
          for="upload-template-html"
          className={css({
            uploadEmailHtml: true,
            uploaded: status === "success" || message?.filename,
          })}
        >
          <input
            type="file"
            id={`upload-template-html`}
            accept=".html"
            onChange={(e) => this.uploadFile(e)}
          />

          <If cond={status !== "uploading"}>
            <div
              className={css({
                icon: true,
                fileUploaded: status === "success" || message?.filename,
                fileUploadedError: status === "error",
              })}
            >
              <Switch value={status}>
                <Case value={"error"}>
                  <i className="far fa-xmark" />
                </Case>
                <Case value={"success"}>
                  <i className="far fa-file-check" />
                </Case>
                <Case value={""}>
                  <i className="fal fa-file-arrow-down" />
                </Case>
              </Switch>
            </div>
          </If>

          <If cond={status === "uploading"}>
            <div className={styles.loading}>
              <span className={styles.loader}></span>
            </div>
          </If>

          <If cond={status === "success" || message?.filename}>
            <span className={styles.fileStatusText}>
              Arquivo carregado com sucesso
            </span>
          </If>

          <If cond={status !== "uploading"}>
            <div className="d-flex align-center">
              <span
                className={css({
                  clickHere: true,
                  uploaded: status === "success" || message?.filename,
                })}
              >
                Clique aqui
              </span>
              <If cond={status === "" && !message?.filename}>
                <span className={styles.text}>
                  para fazer upload de arquivos
                </span>
              </If>
              <If cond={status === "success" || message?.filename}>
                <span className={styles.text}>para alterar o arquivo</span>
              </If>
            </div>
          </If>
        </label>
        {this.renderShootingTest()}
      </>
    );
  }
}
